import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { colors, IMInputText, IMSelect, IMSwissSelect, IMTextArea } from '@insurancemenu/imenu-components-lib';
import { ManageConditionFormFields } from 'store/modules/health-questionnaire/manageConditionModalDelegate';
import { Delete } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DeleteButtonStyled, IMFormStyled } from './styles';

interface Props {
  formController: FormController<ManageConditionFormFields>;
  id: string;
  memberSelectOptions: { value: string; label: string }[];
  isNewMemberForm: boolean;
  deleteForm: () => void;
}

export const FamilyMemberForm: React.FC<Props> = observer(
  ({ formController, id, memberSelectOptions, isNewMemberForm, deleteForm }) => {
    return (
      <IMFormStyled formController={formController} id={id} $isNewMemberForm={isNewMemberForm}>
        {!isNewMemberForm && (
          <DeleteButtonStyled
            leftIconProp={<Delete />}
            size="small"
            uppercase
            type="text"
            color="custom"
            customColor={colors.red[600]}
            onClick={deleteForm}
          >
            Delete Family Member
          </DeleteButtonStyled>
        )}
        <IMSwissSelect
          label="Family Member"
          name="memberId"
          placeholder="Select family member"
          size="full"
          options={memberSelectOptions}
        />
        <IMInputText label="Date Diagnosed" name="dateDiagnosed" htmlType="date" size="m" />
        <IMInputText label="Date Treated" name="dateTreated" htmlType="date" size="m" />
        <IMTextArea label="Treatment" name="treatment" size="full" />
        <IMTextArea label="Medication" name="medication" size="full" />
        <IMSelect
          label="Is treatment ongoing?"
          name="isTreatmentOngoing"
          options={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
          size="full"
        />
        <IMTextArea label="Current or future treatment" name="currentOrFutureTreatment" size="full" hideOnDisabled />
      </IMFormStyled>
    );
  },
);
